import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class JhiMetricsService {
    constructor(private http: HttpClient) {}

    getMetrics(): Observable<any> {
        return this.http.get<any>('management/metrics');
    }

    threadDump(): Observable<any> {
        return this.http.get<any>('management/dump');
    }
}



// WEBPACK FOOTER //
// ./src/app/admin/metrics/metrics.service.ts